module.exports = __webpack_public_path__ + "static/img/pic_3_1@2x.7b0c2a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/peripheralProducts/pic_3_1@2x.png
// module id = m3mD
// module chunks = 0